import { mapState } from "ui.vue3.vuex";

const Modal = {
    computed: {
        ...mapState({
            title: (state) => state.modal.title,
            text: (state) => state.modal.text,
            type: (state) => state.modal.type,
            callback: (state) => state.modal.callback,
        }),
    },

    methods: {
        handleStatementSuccessBtnClick() {
            this.$emit("close");
            this.callback();
        },
    },

    template: /*html*/ `
        <div class="statement-success popup small statement-success_popup"><a class="popup__close">
            <svg class="icon icon-popup-close-icon" @click="handleStatementSuccessBtnClick">
                <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#popup-close-icon'"></use>
            </svg></a>
            <div class="popup__wrapper theme-light" v-if="type === 'statement-success'">
                <div class="popup__title" v-html="title">
                </div>
                <div class="popup__content" v-html="text">
                </div>
                <div class="popup__bottom">
                    <div class="popup__btn popup__btn--center">
                        <button class="btn fill secondary" @click="handleStatementSuccessBtnClick"><span>К списку заявлений</span></button>
                    </div>
                </div>
            </div>

            <div class="popup__wrapper theme-light" v-if="type === 'error'">
                <div class="popup__title" v-html="title">
                </div>
                <div class="popup__content" v-html="text">
                </div>
                <div class="popup__bottom">
                    <div class="popup__btn popup__btn--center">
                        <button class="btn fill secondary" @click="handleStatementSuccessBtnClick"><span>К списку заявлений</span></button>
                    </div>
                </div>
            </div>
        </div>
  `,
};

export default Modal;
